import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ButtonComponent } from './components/button/button.component';
import { ThemeSwitcherComponent } from './components/theme-switcher/theme-switcher.component';
import { InputComponent } from './components/input/input.component';

@NgModule({
  declarations: [ButtonComponent, ThemeSwitcherComponent],
  imports: [CommonModule, IonicModule, InputComponent],
  exports: [ButtonComponent, ThemeSwitcherComponent, InputComponent, IonicModule]
})
export class SharedModule {}
